// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import RegisterPage from './pages/RegisterPage';
import RecoverPage from './pages/RecoverPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import NotFoundPage from './pages/NotFoundPage';
import CookieBanner from './components/CookieBanner';
import AutoUpdate from './components/AutoUpdate';
import GlobalBackgroundVideo from './components/GlobalBackgroundVideo';

function App() {
  return (
    <BrowserRouter>
      <AutoUpdate />
      {/* Fondo global de cadenas animadas (impares hacia abajo, pares hacia arriba) con capa de contraste */}
      <GlobalBackgroundVideo showOverlay={true} />
      <div className="app-wrapper">
        <Navbar />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/r" element={<RegisterPage />} />
            <Route path="/r/recuperar" element={<RecoverPage />} />
            <Route path="/politica-cookies" element={<CookiePolicyPage />} />
            <Route path="/cookies" element={<Navigate to="/politica-cookies" replace />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </BrowserRouter>
  );
}

export default App;
